export default "__VITE_ASSET__lNgAnsFJ__"